module.exports = __webpack_public_path__ + "static/media/IMG_4735.3ad41eb8.jpg";